import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { OverlayManagerService } from './../../services/overlay-manager.service';

// NGRX
import { Store } from '@ngrx/store';
import { AppState } from './../../store/reducers/index';
import { LoginIn } from './../store/auth.actions';
import { userLoginFailure } from './../store/auth.selectors';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
    email: string;
    password: string;
    rememberMe = false;
    errorMessageText = '';
    showResendLink = false;
    getState: Observable<any>;
    @ViewChild('f') form: NgForm;

    userDetailsSubscription = null;
    userLoginErrorSubscription = null;

    constructor(//private broadcastService: BroadcastService,
        private localCacheManager: LocalCacheManager,
        //private loginAndUserManagerService: LoginAndUserManagerService,
        //private router: Router,
        private store: Store<AppState>,
        //private syncOverlayService: SyncOverlayService,
        private overlayManager: OverlayManagerService,
    ) {
        // this.getState = this.store.select(userLogin);
    }

    ngOnInit() {
        this.errorMessageText = '';
        this.userLoginErrorSubscription = this.store.select(userLoginFailure).subscribe(res => {
            if (res && res != null && res.error && res.error != null) {
                this.errorMessageText = res.errorMessageText;
                this.showResendLink = res.showResendLink;
                ErrorHandlerService.handleError(this, res.error, 'onLogin()', false, false);

            }

        });

        this.rememberMe = this.localCacheManager.rememberMe;
        this.email = this.localCacheManager.emailAddress;
    }

    ngOnDestroy() {
        this.errorMessageText = '';

        // this.userDetailsSubscription.unsubscribe();
        this.userLoginErrorSubscription.unsubscribe();
    }

    ngAfterViewInit(): void {

    }

    onKeypress(changes: any) {
        if (this.errorMessageText !== '') {
            this.errorMessageText = '';
        }
    }

    onLogin() {
        this.email = this.form.value['email'];
        this.password = this.form.value['password'];
        this.rememberMe = this.form.value['rememberMe'] as boolean;

        // this.syncOverlayService.ShowProgressOverlay();
        this.overlayManager.showProcessingOverlay.next(`Login...`);
        this.localCacheManager.rememberMe = this.rememberMe;

        this.store.dispatch(LoginIn({ email: this.email, password: this.password, rememberMe: this.rememberMe }));


        // this.loginAndUserManagerService.login(this.email, this.password)
        //     .subscribe(user =>
        //     {
        //         if (user && user.Token)
        //         {
        //             LoggingService.log('User was successfully logged in!', this);

        //             this.localCacheManager.rememberMe = this.rememberMe;
        //             this.localCacheManager.emailAddress = this.rememberMe ? this.email : '';

        //             this.syncOverlayService.HideOverlay();
        //             this.router.navigate([`${this.loginAndUserManagerService.redirectUrl}`]);
        //             return;
        //         }

        //         ErrorHandlerService.handleError(this, new Error('User login failed'), 'onLogin()', false);
        //         this.syncOverlayService.HideOverlay();
        //     }, error =>
        //     {
        //         if (error.status === Toro.HttpResponseStatusCode.Unauthorized)
        //         {
        //             this.errorMessageText = 'Username or password is incorrect.';
        //         }
        //         else if (error.statusText === 'The caller hasn\'t completed the verification process.')
        //         {
        //             this.errorMessageText = 'Your email address has not been verified. Follow instructions in the verification email to complete your registration.';
        //             this.showResendLink = true;
        //         }
        //         else
        //         {
        //             this.errorMessageText = 'A network error has occurred.';
        //         }

        //         ErrorHandlerService.handleError(this, error, 'onLogin()', false, false);
        //         this.syncOverlayService.HideOverlay();
        //     });

    }

    eatClick(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return true;
    }

}
